// Shim esbuild (alias 'react' → questo file): i bundle NON includono React.
// React 18.3.1 UMD self-hosted arriva dal manifest come /vendor/react-18.3.1.min.js
// PRIMA di ogni bundle (B2.2) e vive su window.React — contratto globals V3.
export default window.React;
